"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToDate = void 0;
const string_is_valid_date_1 = require("../../validation/string-is-valid-date/string-is-valid-date");
/**
 * Convert string 'MM/DD/YYYY' to date
 * @public
 *
 * @param value - Date string in 'MM/DD/YY' format
 *
 * @returns Date instance of the string date provided
 *
 * @example
 * ```ts
 * const newDate = stringToDate('02/29/2020');
 * console.log(newDate);
 * // -> 2020-02-29T00:00:00.000Z
 * ```
 */
function stringToDate(value) {
    return (0, string_is_valid_date_1.stringIsValidDate)(value) ? new Date(value) : undefined;
}
exports.stringToDate = stringToDate;
//# sourceMappingURL=string-to-date.js.map